import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { createParentApiMethods } from './methods';
import { toastManager } from './toastManager';

/**
 * Global Parent API object
 * Populated by ParentApiProvider when mounted
 */
export let parentApi = null;

/**
 * ParentApiProvider - React component that initializes the Parent API
 * 
 * This component:
 * 1. Gets dependencies from React hooks (navigate, user)
 * 2. Creates Parent API method implementations
 * 3. Exposes API on window.parentApi and window.siloParentAPI
 * 
 * Usage: Wrap your app with <ParentApiProvider> in App.js
 */
export function ParentApiProvider({ children }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    // Create method implementations
    const methods = createParentApiMethods({
      toastManager: toastManager,
      navigate: navigate,
      user: user
    });

    // Expose on window
    parentApi = methods;
    window.parentApi = methods;
    window.siloParentAPI = methods; // Alias for compatibility


    // Cleanup on unmount
    return () => {
      parentApi = null;
      delete window.parentApi;
      delete window.siloParentAPI;
      initializedRef.current = false;
    };
  }, [navigate, user]);

  return children;
}

// Export toast manager for ToastBridge component
export { toastManager } from './toastManager';

